let elements = {
  //pick: 3,
  blockCheck: true,
  mainImage: {
    imagePath: 'games/page019_game11/img/bcg.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  audio: {
    negative: 'games/page019_game11/audio/false.mp3',
    // positive: 'games/page019_game11/audio/true.mp3',
    click: 'games/page019_game11/audio/click.mp3',
    icon: {
      on: 'games/page019_game11/img/audioOn.png',
      off: 'games/page019_game11/img/audioOff.png',
    },
  },
  itemsConfig: {
    width: 60,
    height: 60,
    background: 'transparent',
  },
  correctItemsConfig: {
    // width: 800,
    // height: 800,
  },
  layoutItems: [
    {
      pos: {
        x: 0,
        y: 0,
      },
    },
  ],
  layoutCorrectItems: [
    {
      pos: {
        x: 382,
        y: 306 - 140,
      },
    },
    {
      pos: {
        x: 876,
        y: 306 - 140,
      },
    },
    {
      pos: {
        x: 1370,
        y: 306 - 140,
      },
    },
  ],
  shuffle: false,
  shuffleCorrect: false,
  shuffleGroups: true,
  shuffleInsideItems: true,
  pick: 0,
  falseStatus: true,
  groups: [
    {
      items: [
        {
          audioSrc: 'games/page019_game11/audio/22_mummy.mp3',
          correct: {
            audioId: 'a01',
            image: {
              src: 'games/page019_game11/img/5.png',
            },
            width: 491,
            height: 557,
            correctItems: {
              images: [
                {
                  src: 'games/page019_game11/img/5g.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 491,
                  height: 557,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            audioId: 'a02',
            image: {
              src: 'games/page019_game11/img/4.png',
            },
            width: 491,
            height: 557,
            incorrectItems: {
              images: [
                {
                  src: 'games/page019_game11/img/4r.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 491,
                  height: 557,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            audioId: 'a03',
            image: {
              src: 'games/page019_game11/img/3.png',
            },
            width: 491,
            height: 557,
            incorrectItems: {
              images: [
                {
                  src: 'games/page019_game11/img/3r.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 491,
                  height: 557,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
  ],
  mbAudioItemData: [
    {
      id: 'a01',
      src: 'games/page019_game11/audio/22_mummy.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page019_game11/img/audioOn.png', iconOff: 'games/page019_game11/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: -60,
        x: 223,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      id: 'a02',
      src: 'games/page019_game11/audio/23_daddy.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page019_game11/img/audioOn.png', iconOff: 'games/page019_game11/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: -60,
        x: 223,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      id: 'a03',
      src: 'games/page019_game11/audio/24_sister.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page019_game11/img/audioOn.png', iconOff: 'games/page019_game11/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: -60,
        x: 223,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
  ],
};

export default elements;
